import React from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { Box, Button, Spacing, Text } from '@reservamos/elements';
import LocalizedCurrency from 'components/LocalizedCurrency';

/**
 * Return reminder to add the return simple ticket for the current trip.
 * @param props - Component props.
 * @param {Function} props.onClick - A function to be called when the button is clicked.
 * @param {number} props.title - Title to show in the card.
 * @param {number} props.price - The price of the return trip.hasBackgroundhasBackground
 * @param {string} props.hasBackground - Flag to indicate if it needs a background.
 * @returns {JSX.Element}
 */
const ReturnCard = ({ onClick, title, price, hasBackground, decimals }) => {
  const { t } = useTranslation();
  const titleToShow = title || t('trips:label.select_schedule');
  return (
    <Box
      bgColor={hasBackground && 'primary'}
      alphaBg="XS"
      borderRadius="M"
      borderColor="primary"
      border="bottom"
      paddingHorizontal="S"
      paddingVertical="S"
      hasShadow
      onClick={onClick}
    >
      <Spacing responsiveSize="S" vertical>
        <Spacing responsiveSize="M" justifyContent="space-between" alignItems="center">
          <Text size="S" weight="semibold" color="grayStrong">
            {titleToShow}
          </Text>

          <Spacing size="XXS" isResponsive alignItems="center" mobileAlign="flex-start">
            <p className="text-xs text-gray-500">{t('general:from')}</p>
            <LocalizedCurrency
              price={price}
              size="M"
              color="grayStrong"
              decimals={decimals}
              currencyLowercase
              weight="bold"
              currencyStyle="currency"
            />
          </Spacing>
        </Spacing>

        <Button
          text={t('common:buttons.add')}
          variant="noFill"
          isRounded
          fontSize="S"
          onClick={onClick}
        />
      </Spacing>
    </Box>
  );
};

ReturnCard.propTypes = {
  onClick: PropTypes.func.isRequired,
  title: PropTypes.string,
  price: PropTypes.number,
  hasBackground: PropTypes.bool,
  decimals: PropTypes.number,
};

ReturnCard.defaultProps = {
  price: 0,
  hasBackground: false,
  decimals: 0,
};

export default ReturnCard;
